<template>
  <div class="page">
    <div style="height: 0.2rem"></div>
    <van-cell-group>
      <div class="box">
        <div v-rblink="{ name: 'CropperImage' }">
          <div style="text-align: center">
            <img :src="row2.face" alt="" class="user-face" />
          </div>
          <h1>设置头像</h1>
        </div>
        <div class="br"></div>
        <van-field
          :value="row.name"
          label="昵称"
          label-width="150"
          is-link
          input-align="right"
          readonly
          @click="toSetUserName"
        />
        <van-field
          :value="row2.phone"
          label="登录手机号"
          label-width="150"
          is-link
          input-align="right"
          readonly
          @click="toSetPhone"
        />
        <van-field
          label="登录密码"
          value="*******"
          label-width="150"
          input-align="right"
          is-link
          readonly
          v-rblink="{ name: 'UserPassword' }"
        />
        <van-field
          value="立即前往"
          label="审核资质申诉&增补"
          label-width="150"
          is-link
          input-align="right"
          readonly
          v-rblink="{ name: 'Qualifications' }"
        />
      </div>
    </van-cell-group>
    <van-cell-group>
      <div class="box">
        <van-field
          :value="cacheSize"
          label="清除缓存"
          label-width="150"
          is-link
          input-align="right"
          readonly
          @click="clearCache"
        />
        <van-field
          value=""
          label="用户反馈"
          label-width="150"
          is-link
          input-align="right"
          readonly
          v-rblink="{ name: 'Feedback' }"
        />
        <!-- <van-field
          :value="status"
          label="消息推送"
          label-width="150"
          input-align="right"
        >
          <template #right-icon>
            <van-switch :value="checked" @input="onInput" />
          </template>
        </van-field> -->
        <!-- <van-field
          value=""
          label="网络诊断"
          label-width="150"
          is-link
          input-align="right"
          readonly
          @click="openSetting"
        /> -->
        <van-field
          value=""
          label="账号注销"
          label-width="150"
          is-link
          input-align="right"
          readonly
          @click="kill"
        />
      </div>
    </van-cell-group>
    <van-cell-group>
      <div class="box">
        <van-field
          value=""
          label="关于我们"
          label-width="150"
          is-link
          input-align="right"
          readonly
          v-rblink="{ name: 'ContentDetail', query: { id: 346 } }"
        />
        <van-field
          value=""
          label="资质证照"
          label-width="150"
          is-link
          input-align="right"
          readonly
          v-rblink="{ name: 'ContentDetail', query: { id: 452 } }"
        />
        <van-field
          value=""
          label="协议规则"
          label-width="150"
          is-link
          input-align="right"
          readonly
          v-rblink="{ name: 'ContentDetail', query: { id: 338 } }"
        />
        <van-field
          value=""
          label="退出登录"
          label-width="150"
          is-link
          input-align="right"
          readonly
          @click="logout"
        />

        <!-- <van-field
          value=""
          label="测试"
          label-width="150"
          is-link
          input-align="right"
          readonly
          v-rblink="{ name: 'Apply331FormStep1', query: {   } }"
        /> -->

      </div>
    </van-cell-group>
  </div>
</template>
<style scoped>
.page {
  background: #f8f8f8;
  width: 100%;
  height: 100%;
  overflow: scroll;
  padding-bottom: 1rem;
}
.van-fields {
  color: #969799;
}
.box {
  padding: 15px;
}
.user-face {
  width: 90px;
  height: 90px;
  border-radius: 90px;
}
.box h1 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  text-align: center;
  margin-top: 15px;
}
.br {
  height: 1px;
  background: #ebedf0;
  margin-top: 10px;
}
.van-cell {
  padding-left: 0;
  padding-right: 0;
}
.van-cell:not(:last-child)::after {
  left: 0;
}
.van-field__label {
  width: 150px;
}
</style>
<script>
import Vue from "vue";
import { ref } from "vue";
import { Switch, Toast, Dialog } from "vant";
Vue.use(Switch).use(Toast).use(Dialog);
export default {
  name: "Setting",
  data: function () {
    return {
      row2: {},
      row: {},
      row3: {},
      cacheSize: 0,
      checked: true,
      status: "",
    };
  },
  activated() {
    this.fetch();
  },
  filter: {},
  mounted() {
    document.title = "账户设置";
    this.fetch();
    let that = this;

    window.rbMessage = function (data) {
      console.log("rbMessage", data);
      data = JSON.parse(data);
      if (data[0] == "cacheSize") {
        that.cacheSize = data[1];
      }
    };
  },
  destroyed() {},
  methods: {
    fetch() {
      let that = this;
      this.$api.get("/api/user/settingdetail", {}, (res) => {
        that.row = res.data;
      });
      this.$api.get("/api/user/userPage", {}, (res) => {
        that.row2 = res.data;
        if (that.row2.userExtra.can_push == 1) {
          this.checked = true;
          this.status = "开启";
        }
        if (that.row2.userExtra.can_push == 2) {
          this.checked = false;
          this.status = "关闭";
        }
      });
      that.row3 = {
        _pspt: localStorage.getItem("_pspt"),
        _token: localStorage.getItem("_token"),
        phone: localStorage.getItem("_phone"),
      };
    },

    toSetUserName() {
      rbLink({ name: "Username" });
    },
    toSetPassWord() {
      rbLink({ name: "Password" });
    },
    toSetPayPassWord() {
      rbLink({ name: "PayPassword" });
    },
    toSetPhone() {
      rbLink({ name: "SetPhone" });
    },
    toAccount() {
      rbLink({ name: "CashAccount" });
    },
    clearCache() {
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: "clearCache",
          query: {},
        });
      } else {
      }
    },
    onInput(checked) {
      Dialog.confirm({
        title: "提醒",
        message: "是否切换开关？",
      }).then(() => {
        this.checked = checked;
        let that = this;
        let canpush = 1;
        if (this.checked == true) {
          canpush = 1;
        }
        if (this.checked == false) {
          canpush = 2;
        }
        this.$api.get("/api/user/changeCanpush", { canpush: canpush }, (r) => {
          this.fetch();
        });
      });
    },
    onUpdate() {
      appEvent({
        name: "FileDownload",
        query: {
          url: "http://fir.dierqudao.com/859v",
        },
      });
    },
    openSetting() {
      appEvent({
        name: "openSetting",
        query: {},
      });
    },
    kill(){ 
      let that = this;
        Dialog.confirm({
            message: '确定注销本账号吗？'
        }).then(() => {

          this.$api.get("/api/user/kill", null, (r) => {
            appEvent({
              name: "logout",
              query: {},
            });
            //that.$toast.fail('正在退出登录');
            localStorage.setItem("_pspt", null);
            localStorage.setItem("_token", null);
            setTimeout(function () {
              rbLink(
                {
                  name: "Index",
                },
                "back"
              );
            }, 500);
          });

        }).catch(() => {
            // on cancel
        });
    },
    logout: function () {
      let that = this;
      this.$api.get("/api/index/logout", null, (r) => {
        appEvent({
          name: "logout",
          query: {},
        });
        //that.$toast.fail('正在退出登录');
        localStorage.setItem("_pspt", null);
        localStorage.setItem("_token", null);
        setTimeout(function () {
          rbLink(
            {
              name: "Index",
            },
            "back"
          );
        }, 500);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Setting.vue?f7ffbdf2